import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Datelocale from "./UI/Datelocale";
import {useIntl} from "react-intl";
import Icon from "@reacticons/bootstrap-icons";
import Doclist from "./UI/Doclist";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Badge from "react-bootstrap/Badge";


const ServiceItem = (props) => {
    const intl = useIntl();
    let status = {1:{title:intl.messages.new, bage:'bg bg-danger', alert:'alert mb-3 alert-danger'}, 2:{title:intl.messages.waiting, bage:'bg bg-warning', alert:'alert mb-3 alert-warning'},3:{title:intl.messages.in_work, bage:'bg bg-info', alert:'alert mb-3 alert-info'},4:{title:intl.messages.ready, bage:'bg bg-success', alert:'alert mb-3 alert-success'},5:{title:intl.messages.canceled, bage:'bg bg-secondary', alert:'alert mb-3 alert-secondary'}}





    return (
        <>
            <Row className={status[props.service.status].alert}>
                <Col lg={4} sm={6} xs={12}>
                    <div>
                        <span className="text-muted">{intl.messages.container}:</span>
                        {props.service.c_number} <span className={status[props.service.status].bage}>{status[props.service.status].title}</span>
                    </div>
                    <div>
                        <span className="text-muted">{intl.messages.created}:</span>
                        <Datelocale date={props.service.created} />
                    </div>
                    <div>
                        <span className="text-muted">{intl.messages.createdBy}:</span>
                        {props.service.createUserName}
                    </div>
                    {props.service.agreed_user_id > 0 ? <>
                        <div>
                            <span className="text-muted">{intl.messages.agreed}:</span>
                            {props.service.agreeUserName}
                        </div>

                    </> : null }

                </Col>
                <Col lg={4} sm={6} xs={12}>

                    <div>
                        {props.service.crane ? <>
                        <span className="text-muted">{intl.messages.crane_operations}:</span>
                        {props.service.crane}  {intl.messages.pc} </>
                            : null }

                    </div>
                    <div>
                        {props.service.type == 'insulation' ? <>
                        <span className="text-muted">
                                    {props.service.nom_text}
                            </span> {props.service.rrsum} ₽ <br/>
                                <span
                                    className="text-muted">{intl.messages.total} : </span> {props.service.rrsum} ₽
                                <br/>
                            </>
                            : <>
                                {props.service.rows.map((rrepair, index) => <>
                                <span className="text-muted">
                                    {localStorage.getItem('locale') == "ru-RU" ? rrepair.name : rrepair.eng }
                                     : </span> {rrepair.price}{props.service.currency} x {rrepair.amount} = {rrepair.sum}{props.service.currency} <br />
                                </>
                            )
                            }
                                <span className="text-muted">{intl.messages.total} : </span> {props.repair.repair} {props.service.currency} <br />
                            </>

                        }

                    </div>


                </Col>
                <Col lg={4} sm={6} xs={12}>
                    <div>
                        <Doclist photo={props.service.photo} />
                        <Badge bg="info" className="pointer" data-id={props.service.id} data-number={props.service.c_number} onClick={props.downloadPhoto} >{intl.messages.download}</Badge>
                    </div>
                    {(props.service.status === 4) ? <>
                        <div>
                            <span className="text-muted">{intl.messages.ready_repair}:</span>
                            <Datelocale date={props.service.completed_date} />
                        </div>

                    </>: null
                    }

                </Col>
                <Col lg={4} sm={6} xs={12}>
                    {(props.service.status === 2) ? <>
                        <button className="btn btn-success" data-id={props.service.id} data-number={props.service.c_number} onClick={props.acceptRepair}  type="button">{intl.messages.accept}</button>
                        <button className="btn btn-danger mx-2" data-id={props.service.id} data-number={props.service.c_number} onClick={props.deniedRepair}  type="button">{intl.messages.refuse}</button>
                    </> : null}
                </Col>

            </Row>
        </>
    );
};

export default ServiceItem;
